import React from "react";

export const SummaryCardIsEditableContext = React.createContext(false);

export function useSummaryCardIsEditable(): boolean {
  return React.useContext(SummaryCardIsEditableContext);
}
